import { PropsWithChildren, useContext } from 'react';
import { Link } from 'react-router-dom';
import ModalContext from '../contexts/ModalContext';

type ModalLinkProps = PropsWithChildren<{
  id: string;
  to: string;
  className?: string;
}>;

export default function ModalLink({ id, to, children, className }: ModalLinkProps) {
  const { closeModal } = useContext(ModalContext);

  return (
    <Link onClick={() => closeModal(id)} to={to} className={className}>
      {children}
    </Link>
  );
}
